export default "__VITE_ASSET__C8W6$QRB__"